import i18next, { use } from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LOCALE, TRANSLATION_IMPORT_BY_LANGUAGE } from './constants';
import { getAppLocale } from './helpers';
import { type Languages } from './types';

export const initI18n = async () => {
  void use(initReactI18next)
    .use(
      resourcesToBackend((language: Languages) =>
        TRANSLATION_IMPORT_BY_LANGUAGE[language]()
      )
    )
    .init({
      lng: await getAppLocale(),
      fallbackLng: !import.meta.env.DEV ? undefined : DEFAULT_LOCALE,
      saveMissing: import.meta.env.DEV,
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
      missingKeyHandler: (lng, _, key, fallbackValue) => {
        console.warn(
          `Missing translation key "${key}" for "${lng}", fallbackValue: "${fallbackValue}"`
        );
        return fallbackValue;
      },
    });

  return i18next;
};
